import { render, staticRenderFns } from "./RepxListView.vue?vue&type=template&id=221e7371"
import script from "./RepxListView.vue?vue&type=script&lang=js"
export * from "./RepxListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports